import angular from 'angular';
import _ from 'lodash';

export default angular.module('registration-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      selfRegistration: {
        PRIMARY_ALREADY_REGISTERED: () => ({ title: gettextCatalog.getString('Primary User for this Retailer is already registered.') }),
        INVALID_OWNER_INFORMATION: () => ({ title: gettextCatalog.getString('Owner information not found or is already registered.') }),
        PASSWORD_REQUIRMENTS_NOT_MET: () => ({ title: gettextCatalog.getString('Password requirements not met.') }),
        USER_ALREADY_EXISTS_EXCEPTION: (params) => ({
          title: gettextCatalog.getString(
            'User with this e-mail address is already registered. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        MULTIPLE_PRIMARY_USER_WITH_SAME_OWNER_EXCEPTION: (params) => ({
          title: gettextCatalog.getString(
            'User for that Owner already exists, please use another ({{ ownerValidationMethod }}) sequence.',
            { ownerValidationMethod: params.ownerValidationMethod }
          ),
        }),
        /// {{ active }} is Lottery term using to determine User status.
        RETAILER_NOT_FOUND: (params) => ({
          title: gettextCatalog.getString(
            'Retailer is not {{ active }} or does not exist in Retail Management. Please contact Administrator.',
            { active: params.terms.ACTIVE.singular }
          ),
        }),
        /// {{ active }} is Lottery term using to determine User status.
        USER_ALREADY_ACTIVE_EXCEPTION: (params) => ({
          title: gettextCatalog.getString('User is already {{ active }}.', { active: params.terms.ACTIVE.singular }),
        }),
        IDENTIFICATION_NOT_VALID: () => ({ title: gettextCatalog.getString('Unable to register subordinate user for this chain head.') }),
        CAPTCHA_NOT_FOUND: () => ({ title: gettextCatalog.getString('Captcha not found. Please reload captcha.') }),
        NOT_AUTHORIZED: (params) => ({
          title: gettextCatalog.getString(
            'User access not allowed due to retailer status. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        USER_WITH_GIVEN_PHONE_ALREADY_EXISTS: () => ({
          title: gettextCatalog.getString(
            "The mobile number you provided is connected to another user's account. Please enter a different mobile number."
          ),
        }),
        USER_WITH_GIVEN_OWNER_ALREADY_EXISTS: () => ({
          title: gettextCatalog.getString(
            "The owner you provided is connected to another user's account. Please enter a different pii data."
          ),
        }),
      },
      completeRegistration: {
        1001: () => ({
          title: gettextCatalog.getString(
            'User already registered. Do not use confirmation link again - it will block Your account otherwise.'
          ),
        }),
        1002: () => ({
          title: gettextCatalog.getString(
            'User already registered. Do not use confirmation link again - it will block Your account otherwise.'
          ),
        }),
        1003: (params) => ({
          title: gettextCatalog.getString(
            'Account has been suspended due to exceeded number of failed login attempts. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        RETAILER_ACCESS_NOT_ALLOWED: (params) => ({
          title: gettextCatalog.getString('Retailer access not allowed. Please call {{ contactPhone }} for assistance.', {
            contactPhone: params.contactPhone,
          }),
        }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/registration/config/errorcodes.conf.js